// 3rd party imports
import * as React from 'react';
import { inject } from 'mobx-react';

// bernie
import { ContextStore, RouteStore } from 'bernie-core';

// shared-ui
import { ILocalization, withLocalization, LocalizedText } from '@shared-ui/localization-context';

// mobx
import { IndustryStore, UserStore } from 'stores';

// ui
import { UitkHeading } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';

// components
import { SignUpForm } from './signup-form';

interface SignUpProps {
  context?: ContextStore;
  industries?: IndustryStore;
  l10n?: ILocalization;
  routeStore?: RouteStore;
  user?: UserStore;
}

interface SignUpState {
  industries: string[];
}

@withLocalization
@inject('industries', 'routeStore', 'user', 'context')
export class SignUp extends React.Component<SignUpProps, SignUpState> {
  public constructor(props) {
    super(props);

    this.state = {
      industries: [],
    };
  }

  public componentDidMount() {
    this.setState({
      industries: this.props.industries.getIndustries(),
    });
  }

  public render() {
    const { context, l10n, routeStore, user } = this.props;

    return (
      <UitkSpacing className="container--small" padding={{ block: 'twelve' }}>
        <main>
          <UitkSpacing padding={{ blockend: 'six' }}>
            <UitkHeading tag="h1" size={3}>
              <LocalizedText message="affiliate.hub.sign.up" />
            </UitkHeading>
          </UitkSpacing>
          <SignUpForm
            context={context}
            industries={this.state.industries}
            l10n={l10n}
            routeStore={routeStore}
            user={user}
            locale={this.props.context.locale}
          />
        </main>
      </UitkSpacing>
    );
  }
}
